export const locale = {
  lang: 'fr',
  data: {
    helpTopic: {
      notifications: {
        actionOk: "L'action s'est complétée avec succès.",
        save: `Sauvegarde de la capsule d'aide en cours ...`
      }
    }
  }
};
